import React from "react";
import { LoginLayout } from "../components";
import { CountDown } from "../features/auth";

const CountDownPage = () => {
  return (
    <LoginLayout>
      <CountDown />
    </LoginLayout>
  );
};

export default CountDownPage;
